import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 * @deprecated since version 8.1.0
 * @tdr-deprecated-date: 2022-04-11
 */
export default svgIcon(React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64" },
    React.createElement("path", { d: "m15 43.8784 9.2504-9.2496 3.4992 3.5 12-12 9.2504 9.2496v-20.3784h-34zm0 4.2432v.8784h19.3784l-10.128-10.128-9.2504 9.2488zm23.6216.8784h10.3784v-9.3784l-9.2504-9.2504-9.8776 9.8792zm-10.6216-24a3 3 0 1 0 -6 0 3 3 0 0 0 6 0zm3 0a6 6 0 1 1 -12 0 6 6 0 0 1 12 0zm-19 27v-40h40v40z", fill: "currentColor" })), 'ImagePlaceholder');
//# sourceMappingURL=ImagePlaceholder.js.map